@if (actionButton) {
    <ng-container *hasPrivilege="actionButton.privilege">
        @switch (actionButton.mode) {
            @case (ACTION_BUTTONS_MODE.StandardButton) {
                @if (isVisible) {
                    <button
                        class="btn {{ btnClass }} d-sm-flex align-items-center"
                        container="body"
                        [disabled]="isDisabled"
                        [clmiUiDynamicFormSetup]="actionButton.formSetup"
                        [attr.data-cy]="actionButton.cySelector"
                        [ngbTooltip]="tooltip"
                        [disableTooltip]="!tooltip"
                        (click)="onActionButtonClicked()"
                    >
                        <ng-content
                            select="action-button-standard"
                        ></ng-content>
                        {{ actionButton.label }}
                    </button>
                }
            }
            @case (ACTION_BUTTONS_MODE.AddButton) {
                <button
                    class="btn {{
                        btnClass
                    }} d-none d-sm-flex align-items-center"
                    container="body"
                    [clmiUiDynamicFormSetup]="actionButton.formSetup"
                    [attr.data-cy]="actionButton.cySelector"
                    [ngbTooltip]="tooltip"
                    [disableTooltip]="!tooltip"
                    (click)="onActionButtonClicked()"
                >
                    <wdx-icon
                        class="me-1"
                        icon="plus"
                        [size]="size || 'fit'"
                    ></wdx-icon>
                    @if (actionButton.label) {
                        <span>{{ actionButton.label }}</span>
                    }
                    <ng-content select="action-button-add"></ng-content>
                </button>
                <atom-icon-button
                    class="d-block d-sm-none"
                    icon="plus"
                    [btnClass]="btnClass"
                    [altText]="actionButton.altText"
                    [tooltip]="tooltip"
                    [cySelector]="actionButton.cySelector"
                    (click)="onActionButtonClicked()"
                ></atom-icon-button>
            }
            @case (ACTION_BUTTONS_MODE.FavouriteButton) {
                <wdx-toggle-button
                    [size]="size"
                    [toggle]="actionButton.isToggledOn"
                    [tooltip]="tooltip"
                    [resetButtonsFlag]="resetButtonsFlag"
                    [cySelector]="actionButton.cySelector"
                    [isDisabled]="isDisabled"
                    (wdxOnChange)="onActionButtonClicked($event)"
                ></wdx-toggle-button>
            }
            @case (ACTION_BUTTONS_MODE.LikeButton) {
                <wdx-toggle-button
                    [iconOn]="ICON_LIKE"
                    [iconOff]="ICON_LIKE"
                    [size]="size"
                    [toggle]="actionButton.isToggledOn"
                    [tooltip]="tooltip"
                    [tooltipPlacement]="tooltipPlacement || 'auto'"
                    [cySelector]="actionButton.cySelector"
                    (wdxOnChange)="onActionButtonClicked($event)"
                ></wdx-toggle-button>
            }
            @case (ACTION_BUTTONS_MODE.LinkedButton) {
                <wdx-toggle-button
                    [iconOn]="ICON_UNLINK"
                    [iconOff]="ICON_LINK"
                    [size]="size"
                    [toggle]="actionButton.isToggledOn"
                    [tooltip]="tooltip"
                    [cySelector]="actionButton.cySelector"
                    (wdxOnChange)="onActionButtonClicked($event)"
                ></wdx-toggle-button>
            }
            @case (ACTION_BUTTONS_MODE.IconButton) {
                @if (isVisible) {
                    <atom-icon-button
                        [size]="size"
                        [icon]="actionButton.icon"
                        [btnClass]="btnClass"
                        [disabled]="isDisabled"
                        [altText]="actionButton.altText"
                        [tooltip]="tooltip"
                        [formSetup]="actionButton.formSetup"
                        [cySelector]="actionButton.cySelector"
                        (onClick)="onActionButtonClicked()"
                    ></atom-icon-button>
                }
            }
            @case (ACTION_BUTTONS_MODE.UploadButton) {
                <input
                    #fileUpload
                    type="file"
                    class="d-none"
                    (change)="onFileSelected($event)"
                />
                @if (isVisible) {
                    <atom-icon-button
                        [size]="size"
                        icon="upload"
                        [btnClass]="btnClass"
                        [disabled]="isDisabled"
                        [altText]="actionButton.altText"
                        [tooltip]="tooltip"
                        [cySelector]="actionButton.cySelector"
                        (onClick)="fileUpload.click()"
                    ></atom-icon-button>
                }
            }
            @case (ACTION_BUTTONS_MODE.DropdownButtonAdd) {
                <ng-container
                    *ngTemplateOutlet="
                        dropdownTemplateId;
                        context: {
                            hideDropdownChevron: hideDropdownChevron,
                            btnClass: btnClass,
                        }
                    "
                ></ng-container>
            }
            @case (ACTION_BUTTONS_MODE.DropdownButtonAddSearch) {
                <ng-container
                    *ngTemplateOutlet="
                        dropdownTemplateId;
                        context: {
                            hideDropdownChevron: hideDropdownChevron,
                            btnClass: btnClass,
                        }
                    "
                ></ng-container>
            }
            @case (ACTION_BUTTONS_MODE.DropdownButtonMenu) {
                <ng-container
                    *ngTemplateOutlet="
                        dropdownTemplateId;
                        context: {
                            hideDropdownChevron: true,
                            btnClass: btnClass + ' btn-icon',
                        }
                    "
                ></ng-container>
            }
            @case (ACTION_BUTTONS_MODE.DropdownButtonMenuWithLabel) {
                <ng-container
                    *ngTemplateOutlet="
                        dropdownTemplateId;
                        context: {
                            hideDropdownChevron: hideDropdownChevron,
                            btnClass: btnClass,
                        }
                    "
                ></ng-container>
            }
            @case (ACTION_BUTTONS_MODE.DropdownButtonIcon) {
                <ng-container
                    *ngTemplateOutlet="
                        dropdownTemplateId;
                        context: {
                            hideDropdownChevron: true,
                            btnClass: btnClass + ' btn-icon',
                        }
                    "
                ></ng-container>
            }
        }
    </ng-container>
}

<ng-template
    #dropdownTemplateId
    let-hideDropdownChevron="hideDropdownChevron"
    let-btnClass="btnClass"
>
    @if (isVisible) {
        <molecule-context-menu-dropdown
            [size]="dropdownMenuSize"
            [placement]="dropdownPlacement"
            [menu]="dropdownMenu"
            [menuTitle]="actionButton.dropdownMenuTitle"
            [btnClass]="btnClass"
            [altText]="actionButton.altText"
            [tooltip]="tooltip"
            [buttonStyle]="
                dropdownButtonStyle !== undefined
                    ? dropdownButtonStyle
                    : DEFAULT_DROPDOWN_BUTTON_STYLE
            "
            [parentContainer]="parentContainer"
            [hasSearch]="
                actionButton.mode ===
                ACTION_BUTTONS_MODE.DropdownButtonAddSearch
            "
            [hideDropdownChevron]="hideDropdownChevron"
            [highlightSelected]="highlightSelectedMenuItem"
            [autoClose]="dropdownAutoClose"
            [disabled]="isDisabled"
            [isLoading]="isLoading"
            [cySelector]="actionButton.cySelector"
            (singleItemSelected)="menuItemSelected($event)"
            (toggled)="onDropdownToggled($event)"
        >
            @if (
                actionButton.mode === ACTION_BUTTONS_MODE.DropdownButtonAdd ||
                actionButton.mode ===
                    ACTION_BUTTONS_MODE.DropdownButtonAddSearch
            ) {
                <wdx-icon class="me-1" icon="plus" [size]="size"></wdx-icon>
                <span class="d-none d-sm-block me-1">
                    <ng-content></ng-content>
                </span>
            }
            @if (actionButton.mode === ACTION_BUTTONS_MODE.DropdownButtonMenu) {
                <wdx-icon-container [size]="size" [attr.data-cy]="actionButton.cySelector">
                    <wdx-icon icon="ellipsis-h" iconStyle="fas"></wdx-icon>
                </wdx-icon-container>
            }
            @if (
                actionButton.mode ===
                ACTION_BUTTONS_MODE.DropdownButtonMenuWithLabel
            ) {
                @if (actionButton.icon) {
                    <wdx-icon
                        class="me-1"
                        [icon]="actionButton.icon"
                    ></wdx-icon>
                }
                <span
                    >{{
                        actionButton.label | translateTokenisedString
                    }}&nbsp;</span
                >
            }
            @if (actionButton.mode === ACTION_BUTTONS_MODE.DropdownButtonIcon) {
                <wdx-icon-container [size]="size" [attr.data-cy]="actionButton.cySelector">
                    @if (isVisible) {
                        <wdx-icon [icon]="actionButton.icon"></wdx-icon>
                    }
                </wdx-icon-container>
            }
        </molecule-context-menu-dropdown>
    }
</ng-template>
